import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const fixedExpenseService = {
  fetchWithPivot: async (params = {}) => {
    const response = await axiosInstance.get('/fixed-expense-cost/with-pivot', {
      params,
    })
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/fixed-expense-cost/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
      const response = await axiosInstance.get('/fixed-expense-cost/' + id)
    return response.data
  },
  store: async (data) => {
      const response = await axiosInstance.post('/fixed-expense-cost', data)
      return response.data
  },
  storeWithCategory: async (data) => {
      const response = await axiosInstance.post('/fixed-expense-cost/store-with-category', data)
      return response.data
  },
  update: async (data) => {
      const response = await axiosInstance.put(`/fixed-expense-cost/${data.id}`, data)
      return response.data
  },
  updateWithCategory: async (data) => {
      const response = await axiosInstance.put(`/fixed-expense-cost/${data.id}/with-category`, data)
      return response.data
  },
  delete: async (id) => {
      const response = await axiosInstance.delete(`/fixed-expense-cost/${id}`)
      return response.data
  },
}